import React from 'react';
import PropTypes from 'prop-types';

function PitchSVG({ width, height, color = '#fff', background = '#ecedea' }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width || null} height={height || null} viewBox="0 0 950 1172">
            <g fill="none" fillRule="evenodd">
                <path fill={background} d="M125.0435 0h699.0469l125.0435 1171.1106H0z" />
                <g fill={color} opacity=".8" transform="translate(13.6675 8.077)">
                    <path
                        fillRule="nonzero"
                        d="M.3428 1142.7719l.367-3.8399L117.9987 1.0505h684.958l117.6518 1141.7214H.3428zm915.5236-6.6434L800.4007 3.5798H120.5546L5.0848 1136.1285h910.7816z"
                    />
                    <path
                        fillRule="nonzero"
                        d="M353.1158 504.9818c0-49.5178 48.1533-88.8987 107.3417-88.8987 59.1885 0 107.3417 39.3809 107.3417 88.8987 0 49.5179-48.1532 89.8038-107.3417 89.8038-59.1884 0-107.3417-40.286-107.3417-89.8038zm2.6502 0c0 47.3356 46.9633 85.8433 104.6915 85.8433 57.7283 0 104.6916-38.5096 104.6916-85.8433 0-47.3336-46.9647-85.8433-104.6916-85.8433-57.7269 0-104.6915 38.5077-104.6915 85.8433z"
                    />
                    <path
                        fillRule="nonzero"
                        d="M850.9507 498.3473H70.1262v-3.4398h780.8245zM540.9788 38.6699H382.5026l2.0207-35.8764 1.9625-.0323-1.3027 33.6129h153.1167l-1.3041-33.6129 1.9624.0323z"
                    />
                    <path
                        fillRule="nonzero"
                        d="M294.211 107.8571L304.459 2.8296l2.8856-.1045-9.5917 102.3059h328.8244L616.9871 2.7251l2.8856.1045 10.2466 105.0275z"
                    />
                    <path
                        fillRule="nonzero"
                        d="M418.3927 107.7734l2.3775-.8396c6.053 13.6747 22.6483 22.8617 41.2936 22.8617 18.6452 0 35.239-9.1846 41.2906-22.8569l2.3775.8396c-6.5759 14.8604-24.1256 24.8434-43.6681 24.8434-19.5425 0-37.0938-9.9855-43.671-24.8482zM118.3482 12.5157l-.6038-1.5932c2.7153-.0139 5.3399.0517 8.502-2.2458 3.1623-2.2975 4.5222-3.884 4.824-7.3192l1.4349.5207c-.3598 3.4338-1.4353 5.451-4.7497 7.8591-3.3144 2.408-6.5007 2.851-9.4074 2.7784zM802.7156 13.0324l.6038-1.5932c-2.7154-.014-5.3399.0516-8.502-2.2459-3.1623-2.2974-4.5222-3.884-4.824-7.3192l-1.4349.5207c.3598 3.4339 1.4353 5.4511 4.7497 7.8591 3.3144 2.408 6.5007 2.851 9.4074 2.7785zM343.3626 1138.0777l3.1239-65.7603h230.7632l3.1224 65.7603-2.9186.9639-2.7053-63.6604H348.9895l-2.7082 63.6604z"
                    />
                    <path
                        fillRule="nonzero"
                        d="M220.1045 1138.1154l12.4168-189.867h459.9081l11.8044 189.8844-2.9275.8507-11.4287-187.6712H235.0583l-12.0292 187.6887z"
                    />
                    <path
                        fillRule="nonzero"
                        d="M462.3274 906.515c-26.5519 0-50.7414 19.2641-56.2636 44.8055l-2.7249-2.2676c5.9601-27.5592 31.3197-45.599 58.9885-45.599 27.6925 0 53.0551 18.063 58.996 45.6513l-2.725 2.2588c-5.5059-25.5704-29.6968-44.849-56.271-44.849z"
                    />
                    <ellipse cx="462.1992" cy="73.6411" rx="2.2859" ry="2.4082" />
                    <ellipse cx="462.1992" cy="496.5161" rx="4.1145" ry="4.3347" />
                </g>
            </g>
        </svg>
    );
}

PitchSVG.propTypes = {
    width: PropTypes.string,
    height: PropTypes.string,
    color: PropTypes.string,
    background: PropTypes.string
};

export default PitchSVG;



/** WEBPACK FOOTER **
 ** ../src/dash/front/grid-maker-tool-page/components/PitchSVG.js
 **/